import { getTokenAbi } from '@frontend/app/(routes)/go/send/components/footer/ApproveButton';
import { getTokenByAddress } from '@yodlpay/tokenlists';
import { Address } from 'viem';

export const buildContractCallForBalance = (
  token: Address,
  chainId: number,
  address: Address,
) => {
  const tokenInfo = getTokenByAddress(token, chainId);

  if (!tokenInfo) {
    throw new Error(`Token not found: ${token} on chain ${chainId}`);
  }

  return {
    address: token,
    abi: getTokenAbi(tokenInfo.symbol, chainId),
    functionName: 'balanceOf',
    args: [address],
  };
};
